export type DeployEnv = 'staging' | 'testing' | 'production'

export const DEPLOY_ENVS: readonly DeployEnv[] = ['staging', 'testing', 'production']

export const DEFAULT_ENV: DeployEnv = 'staging'

// Domain mapping mirrors frontend-packages/web-data/src/shared/environment.ts in the
// Chili-Piper/frontend monorepo: cpcdp.{io|in|com} for the tracking domain and
// chilipiper.{io|in|com} for the tenant domain.
const cpcdpDomain = (env: DeployEnv): string => {
  if (env === 'staging') return 'cpcdp.io'
  if (env === 'testing') return 'cpcdp.in'
  return 'cpcdp.com'
}

const chilipiperDomain = (env: DeployEnv): string => {
  if (env === 'staging') return 'chilipiper.io'
  if (env === 'testing') return 'chilipiper.in'
  return 'chilipiper.com'
}

/** The customer-installed tracking script URL — served from the tenant's dedicated cpcdp domain. */
export const trackingScriptUrl = (env: DeployEnv, tenantSubdomain: string): string =>
  `https://${tenantSubdomain}.${cpcdpDomain(env)}/web-data/tracking/index.js`

/** The deanonymization embed URL — served from the tenant's chilipiper domain. */
export const deanonEmbedUrl = (env: DeployEnv, tenantSubdomain: string): string =>
  `https://${tenantSubdomain}.${chilipiperDomain(env)}/web-data/deanonymization/embed/index.js`

/** Jitsu ingest base URL — where page/track/identify events land. */
export const ingestBaseUrl = (env: DeployEnv): string => `https://ingest.j.${cpcdpDomain(env)}`

/** Tenant API base (targeted by the deanon iframe) — used by the Network checklist. */
export const tenantApiBaseUrl = (env: DeployEnv, tenantSubdomain: string): string =>
  `https://${tenantSubdomain}.${chilipiperDomain(env)}`
